import type { ReactNode } from 'react';

type Tone = 'primary' | 'success' | 'warning' | 'error' | 'info' | 'neutral';

const toneClasses: Record<Tone, string> = {
  primary: 'bg-primary-50 text-primary-800 ring-1 ring-inset ring-primary-100',
  success: 'bg-success-bg text-success ring-1 ring-inset ring-success-border/60',
  warning: 'bg-warning-bg text-warning ring-1 ring-inset ring-warning-border/60',
  error: 'bg-error-bg text-error ring-1 ring-inset ring-error-border/60',
  info: 'bg-info-bg text-info ring-1 ring-inset ring-info-border/60',
  neutral: 'bg-surface-muted text-ink-faint ring-1 ring-inset ring-border-subtle',
};

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center text-[10.5px] font-semibold tracking-tight px-2 py-0.5 rounded-full whitespace-nowrap ${toneClasses[tone]}`}>
      {children}
    </span>
  );
}
